/**
 * Mapea errores tecnicos del API a copy argentino para el usuario final.
 * Si un error no esta mapeado, devuelve un fallback amable (no el codigo crudo).
 */
const MESSAGES: Record<string, string> = {
  network_error: 'No te pudimos conectar. Fijate la conexión y probá de nuevo.',
  invalid_response: 'Algo se rompió del lado nuestro. Avisanos.',
  invalid_body: 'Algo del formulario no llegó bien. Refrescá la página.',
  invalid_email: 'Ese mail no es válido.',
  weak_password: 'La contraseña tiene que tener al menos 8 caracteres.',
  invalid_name: 'Tu nombre tiene que tener al menos 2 letras.',
  invalid_salon_name: 'El nombre del salón tiene que tener al menos 2 letras.',
  invalid_slug: 'El nombre del salón no nos sirve para hacer un link. Probá con otro.',
  email_taken: 'Ese mail ya está usado en Tijera. Probá iniciar sesión.',
  slug_taken: 'Ya hay otra barbería con ese nombre. Cambialo un toque.',
  invalid_credentials: 'Email o contraseña incorrectos.',
  user_inactive: 'Tu usuario está desactivado. Hablá con el dueño del salón.',
  no_token: 'Te tenés que loguear primero.',
  invalid_or_expired: 'Tu sesión venció. Volvé a entrar.',
  not_found: 'No encontramos lo que buscás.',
  internal_error: 'Algo se rompió de nuestro lado. Probá de nuevo en un toque.',
  server_misconfigured: 'El sistema está mal configurado. Avisanos.',
};

export function errorCopy(code: string): string {
  return MESSAGES[code] ?? 'Algo salió mal. Probá de nuevo.';
}
